/**
 * govTier.ts — 법인별 관급/사급 판정 (2026-10-22 경원 준비 3차 C 결정).
 *
 * 관급은 키워드가 아니라 **거래처 코드 화이트리스트**로 정한다.
 *   - 중앙(레미콘): `C023` (ERP 영업 거래처 코드)
 *   - 경원(아스콘): `A002` 전남제일아스콘사업협동조합 · `A034` 한국도로공사 남부도로개량사업단 (OKIS CUSTOMER.GRCD)
 *     `A033` 영광축산업협동조합은 이름에 "조합"이 있어도 사급 — 이름으로 판정하지 않는다.
 *
 * 중앙 기존 판정(`domain/sales.ts` GOV_CUSTOMER_CODES·`domain/rqc.ts` classifyTier)은 지금 그대로 두고,
 * 법인 경로 이전(설계 10 묶음 ①②) 때 이 표로 합친다.
 * 순수 상수·함수만. Firebase import 금지(domain 규칙).
 */
import type { TenantKey } from "./space";

export type GovTier = "gov" | "cust";

export const GOV_CUSTOMER_CODES_BY_TENANT: Record<TenantKey, ReadonlySet<string>> = {
  joongang: new Set(["C023"]),
  gyeongwon: new Set(["A002", "A034"]),
};

export function classifyTierFor(tenant: TenantKey, customerCode: string | null | undefined): GovTier {
  return GOV_CUSTOMER_CODES_BY_TENANT[tenant].has((customerCode ?? "").trim()) ? "gov" : "cust";
}
